// 部门管理接口
import http from '../utils/request'

export default {
  // 获取角色列表
  roleList(data) {
    return http.get('/pc/clientApi/role/roleList', { params: data })
  },
  // 新增角色
  addRole(data) {
    return http.post('/pc/clientApi/role/addRole', data)
  },
  // 获取角色详情
  detailRole(data) {
    return http.get('/pc/clientApi/role/roleDetail/' + data)
  },
  // 编辑角色
  updateRole(data) {
    return http.post('/pc/clientApi/role/editRole', data)
  },
  // 删除角色
  delRole(data) {
    return http.post('/pc/clientApi/role/deleteRole/' + data)
  },

  // 获取员工列表
  userList(data) {
    return http.get('/pc/clientApi/worker/userList', { params: data })
  },
  // 新增员工
  addUser(data) {
    return http.post('/pc/clientApi/worker/addUser', data)
  },
  // 员工详情
  userDetail(data) {
    return http.get('/pc/clientApi/worker/userDetail/' + data)
  },
  // 编辑员工
  editUser(data) {
    return http.post('/pc/clientApi/worker/editUser', data)
  },
  // 删除员工
  delUser(data) {
    return http.post('/pc/clientApi/worker/deleteWorker/' + data)
  },

  // 部门列表
  deptList(data) {
    return http.get('/pc/clientApi/dept/deptList', { params: data })
  },
  // 部门详情
  deptDetail(data) {
    return http.get('/pc/clientApi/dept/deptDetail/' + data)
  },
  // 编辑部门
  editDept(data) {
    return http.post('/pc/clientApi/dept/editDept', data)
  },
  // 新增部门
  addDept(data) {
    return http.post('/pc/clientApi/dept/addDept', data)
  },
  // 删除部门
  deleteDept(data) {
    return http.post('/pc/clientApi/dept/deleteDept/' + data)
  },
  // 部门员工列表
  deptWorkerList(data) {
    return http.get('/pc/clientApi/dept/deptWorkerList', { params: data })
  },
  // 删除部门员工
  deleteDeptUser(data) {
    return http.post('/pc/clientApi/dept/deleteDeptUser', data)
  }
}
